import React from 'react';
import styled from 'styled-components';

import { IAdvertising, ISpecOfferLabel, ISpecOfferPicture } from '@r1-frontend/api-domru/spec-offer/v1/spec-offers/dto/ISpecOffer';

import { wideBreakpoints } from '@r1-frontend/ui-react/components/layouts/wideContainer';
import WebpImage from '@r1-frontend/ui-react/components/WebpImage';
import { NonStaticContainer, RounderContainer } from '@r1-frontend/ui-react/experimental/containers';
import { AdvertisingLabelWithTooltip } from '@r1-frontend/ui-react/organisms/AdvertisingLabelWithTooltip';

import LabelsList from '~/src/features/specialOffersContainer/components/LabelsList';

interface IImage extends ISpecOfferPicture {
    alt: string,
}

interface IProps {
    image: IImage,
    labels?: ISpecOfferLabel[],
    advertising?: IAdvertising,
    className?: string,
}

const HeaderImage = ({ image, labels, advertising, className }: IProps): JSX.Element => {
    return (
        <RounderContainer $desktop={24} $mobile={16} className={className}>
            {!!labels?.length && (
                <NonStaticContainer
                    $desktop={{ $top: 24, $left: 24 }}
                    $mobile={{ $top: 16, $left: 16 }}
                >
                    <LabelsList labels={labels}/>
                </NonStaticContainer>
            )}

            <WebpImage urlWebp={image.urlWebp}>
                <img src={image.url} alt={image.alt}/>
            </WebpImage>

            {advertising && (
                <NonStaticContainer
                    $desktop={{ $bottom: 12, $right: 12 }}
                    $mobile={{ $bottom: 8, $right: 8 }}
                >
                    <AdvertisingLabelWithTooltip
                        onClick={e => e.stopPropagation()}
                        companyName={advertising.companyName}
                        erid={advertising.erid}
                        tooltip={{ position: 'top-right', zIndex: 1024 }}
                    />
                </NonStaticContainer>
            )}
        </RounderContainer>
    );
};

export default styled(HeaderImage)`
    position: relative;
    width: 100%;
    height: 192px;

    img,
    picture {
        width: 100%;
        height: 100%;
        object-position: center;
        object-fit: cover;
    }

    @media (min-width: ${wideBreakpoints.mobile}) {
        height: 312px;
    }
`;
